import WidgetBoard from '../../../../components/WidgetBoard';
import type { EcosystemDefinition, EcosystemProject } from '@frontend/types';
import type { EcosystemServiceOverview } from '@frontend/pages/dashboard/types';

interface EcosystemDetailProps {
  ecosystemId: string;
  ecosystemDefs: EcosystemDefinition[];
  projects: EcosystemProject[];
  selectedOverview: EcosystemServiceOverview | null;
  onSelectProject: (ecosystemId: string, projectId: string) => void;
}

export default function EcosystemDetail({ ecosystemId, ecosystemDefs, projects, selectedOverview, onSelectProject }: EcosystemDetailProps) {
  const ecoLabel = ecosystemDefs.find((e) => e.id === ecosystemId)?.displayName || ecosystemId;
  const workPackages = selectedOverview?.openproject?.myWorkPackages || [];
  const openIssues = selectedOverview?.gitea?.openIssues || [];
  const recentFiles = selectedOverview?.nextcloud?.recentFiles || [];

  return (
    <div className="tree-dashboard-panel">
      <h2>{ecoLabel}</h2>
      <p className="tree-dashboard-muted">
        Ecosystem scope view across OpenProject, Gitea, and Nextcloud for all mapped projects.
      </p>

      <div className="tree-dashboard-metrics">
        <div className="tree-dashboard-metric-card">
          <div className="tree-dashboard-metric-label">Projects</div>
          <div className="tree-dashboard-metric-value">{projects.length}</div>
        </div>
        <div className="tree-dashboard-metric-card">
          <div className="tree-dashboard-metric-label">Work Packages</div>
          <div className="tree-dashboard-metric-value">{workPackages.length}</div>
        </div>
        <div className="tree-dashboard-metric-card">
          <div className="tree-dashboard-metric-label">Open Issues</div>
          <div className="tree-dashboard-metric-value">{openIssues.length}</div>
        </div>
        <div className="tree-dashboard-metric-card">
          <div className="tree-dashboard-metric-label">Recent Files</div>
          <div className="tree-dashboard-metric-value">{recentFiles.length}</div>
        </div>
      </div>

      <h3 className="tree-dashboard-section-title">Projects In Ecosystem</h3>
      {projects.length === 0 ? (
        <p className="tree-dashboard-muted">No projects currently mapped.</p>
      ) : (
        <div className="tree-dashboard-project-list">
          {projects.map((project) => (
            <button
              key={project.id}
              type="button"
              className="tree-dashboard-project-row"
              onClick={() => onSelectProject(ecosystemId, project.id)}
            >
              <div>
                <div className="tree-dashboard-project-name">{project.name}</div>
                <div className="tree-dashboard-muted">{project.description || 'No description yet.'}</div>
              </div>
              <span className="tree-dashboard-project-open">Open</span>
            </button>
          ))}
        </div>
      )}

      <WidgetBoard contextType="ecosystem" contextId={ecosystemId} ecosystemId={ecosystemId} ecosystemServices={ecosystemDefs.find((e) => e.id === ecosystemId)?.services} />
    </div>
  );
}
